<div class="login-container flex justify-center items-center">
    <form class="login-form" [formGroup]="updatePasswordForm">
        <h1 class="login-title">Update Password</h1>

        <div class="form-group">
            <label for="username">Old Password</label>
            <div class="password-input">
                <img class="lock-icon" src="assets/images/lock-icon.svg" />
                <input id="oldPassword" type="password" formControlName="oldPassword" autocomplete="off" class="username" />
            </div>
            <div *ngFor="let error of getErrors('oldPassword')" class="error-message">
                {{ error }}
            </div>
        </div>

        <div class="form-group">
            <label for="newPassword">New Password</label>
            <div class="password-input">
                <img class="lock-icon" src="assets/images/lock-icon.svg" />
                <input id="newPassword" type="password" formControlName="newPassword" class="password" autocomplete="off" />
            </div>
            <div *ngFor="let error of getErrors('newPassword')" class="error-message">
                {{ error }}
            </div>
        </div>

        <div class="form-group">
            <label for="confirmPassword">Confirm Password</label>
            <div class="password-input">
                <img class="lock-icon" src="assets/images/lock-icon.svg" />
                <input id="confirmPassword" type="password" formControlName="confirmPassword" class="password" autocomplete="off" />
            </div>
            <div *ngFor="let error of getErrors('confirmPassword')" class="error-message">
                {{ error }}
            </div>
        </div>
        <button type="button" class="login-button" (click)="updatePassword()" [disabled]="updatePasswordForm.invalid">Update Password</button>
    </form>
</div>
<p-toast></p-toast>
